module.exports = __webpack_public_path__ + "img/paystatusPopup_success.bb9db8ef.png";